import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { SCHOOL_LEGAL_SECTIONS } from '../content/schoolLegalContent'

const SchoolLegalTerms: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <header className="flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-primary-600 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>
        <Link to="/register" className="flex items-center">
          <img src="/logo.png" alt="BookMyYogaTTC" className="h-9 w-auto" />
        </Link>
        <div className="w-[120px]" aria-hidden />
      </header>

      <main className="flex-1 overflow-y-auto">
        <div className="max-w-3xl mx-auto px-6 py-10">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
            Terms of Service &amp; Privacy Policy
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            For yoga schools using Bookmyyogattc. Last updated: March 2025.
          </p>

          <div className="mt-6 flex flex-wrap gap-4 text-sm">
            <Link to="/register" className="text-primary-600 hover:text-primary-700 hover:underline">
              Register
            </Link>
            <Link to="/claim-profile" className="text-primary-600 hover:text-primary-700 hover:underline">
              Claim profile
            </Link>
            <Link
              to="/documentation/payment-terms"
              className="text-primary-600 hover:text-primary-700 hover:underline"
            >
              Payment terms
            </Link>
          </div>

          <div className="mt-10 space-y-8 text-sm text-gray-600">
            {SCHOOL_LEGAL_SECTIONS.map((section) => (
              <section key={section.id}>
                <h2 className="text-base font-semibold text-gray-900 mb-2">{section.title}</h2>
                {section.paragraphs?.map((p) => (
                  <p key={p.slice(0, 48)} className="leading-relaxed mb-2">
                    {p.includes('info@') ? (
                      <>
                        Questions:{' '}
                        <a
                          href="mailto:info@bookmyyogattc.com"
                          className="text-primary-600 hover:text-primary-700 hover:underline"
                        >
                          info@bookmyyogattc.com
                        </a>
                      </>
                    ) : (
                      p
                    )}
                  </p>
                ))}
                {section.bullets && section.bullets.length > 0 && (
                  <ul className="list-disc list-inside space-y-1">
                    {section.bullets.map((b) => (
                      <li key={b}>{b}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </div>
        </div>
      </main>
    </div>
  )
}

export default SchoolLegalTerms
